// colors
import { colors } from '../../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  card: {
    borderRadius: 8,
    backgroundColor: colors.white,
    width: '100%',
    '&:hover $topRight': {
      opacity: 1,
      visibility: 'visible',
    },
  },
  subtitle: {
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral600,
  },
  rowCenter: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
  },
  flexStart: {
    alignItems: 'flex-start',
  },
  topLeftHead: {
    display: 'flex',
    gap: 24,
    marginBottom: 8,
  },
  borderTop: {
    borderTop: `1px solid ${colors.neutral100}`,
    padding: 24,
  },
  topRight: {
    display: 'flex',
    gap: 20,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.2s ease, visibility 0.2s ease',
  },
  badge: {
    minWidth: 'fit-content',
  },
  badgeMisreported: {
    backgroundColor: colors.secondary50,
    color: colors.secondary500,
  },
  title: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 700,
    cursor: 'pointer',
  },
  title2: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    color: colors.neutral600,
  },
  btn: {
    fontSize: 14,
    '& svg': {
      marginRight: 8,
      width: 16,
    },
  },
  username: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    margin: 0,
  },
  time: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    margin: 0,
    color: colors.neutral600,
  },
  notes: {
    marginTop: 24,
    display: 'block',
  },
  interference: {
    '& svg path': {
      fill: colors.neutral500,
    },
  },
  interferenceResolved: {
    '& svg path': {
      fill: `${colors.secondary500} !important`,
    },
    '& $time': {
      color: `${colors.secondary500} !important`,
    },
  },
  bottomBox: {
    marginTop: 16,
    marginBottom: 12,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: colors.neutral500,
    display: 'block',
    marginBottom: 4,
  },
  value: {
    color: colors.neutral900,
  },
});
